import { ReactNode } from 'react';

type QuickActionsProps = {
    children: ReactNode | ReactNode[];
};

/**
 * Quick actions section at the bottom left of the card
 * Could consist of badge or action button
 */
function QuickActions({ children }: QuickActionsProps): JSX.Element {
    return <>{children}</>;
}

export default QuickActions;
